<div class="">
  <!-- Content Header -->
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">
            Events
            <button type="button" class="btn btn-sm btn-primary ms-1 btn-" (click)="openEventModal()" title="Add Event">
              <i class="fas fa-plus"></i>
            </button>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <!-- Events Table -->
  <div class="card glass-card border-0 shadow-lg rounded-4 p-3">
    <div class="table-responsive table-scroll-wrapper">
      <table class="table table-hover stylish-table align-middle mb-0">
        <thead class="text-white table-header">
          <tr>
            <th class="text-center">Sr.No</th>
            <th class="text-center">Main Event Name</th>
            <th class="text-center">Sub Events</th>
            <th class="text-center">Actions</th>
          </tr>
        <tbody>
          <tr *ngFor="let event of events; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td class="fw-semibold text-center">{{ event.mainEventName }}</td>
            <td class="text-center">{{ getSubEventNames(event.subEvents) }}</td>
            <td class="text-center">
              <i class="bi bi-eye icon-action text-success" title="View Event Details"
                (click)="viewEvent(event.mainEventSeq)" style="cursor: pointer; margin-right: 10px;"></i>
              <i class="bi bi-pencil-square icon-action text-primary" title="Edit Event"
                (click)="editEvent(event.mainEventSeq)" style="cursor: pointer; margin-left: 5px;"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- No Events Message -->
  <div class="alert alert-info" *ngIf="events.length === 0">
    <p class="mb-0">No events found. Click the <strong><i class="fas fa-plus"></i></strong> button above to add a new
      event.</p>
  </div>
</div>

<!-- Event Modal -->
<div class="modal fade" id="eventModal" tabindex="-1" [ngClass]="{'show': showEventModal}"
  [style.display]="showEventModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 class="modal-title mb-0">{{ eventForm.get('mainEventName')?.value ? 'Edit Event' : 'Add Event' }}</h5>
          <!-- Main Event Delete Icon -->
          <button *ngIf="eventForm.get('mainEventName')?.value && eventForm.get('mainEventSeq')?.value" type="button"
            class="btn btn-sm btn-danger ms-3" title="Delete Main Event"
            (click)="deleteMainEvent(eventForm.get('mainEventSeq')?.value)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <button type="button" class="btn-close" (click)="closeEventModal()"></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="eventForm">
          <!-- Main Event Name Only -->
          <div class="form-group mb-3">
            <label for="mainEventName">Main Event Name</label>
            <input type="text" class="form-control" id="mainEventName" formControlName="mainEventName"
              placeholder="Enter main event name">
          </div>

          <div class="form-group mb-3">
            <label for="mainEventLink">Main Event Link</label>
            <input type="text" class="form-control" id="mainEventLink" formControlName="mainEventLink"
              placeholder="Enter main event Link">
          </div>


          <hr>

          <!-- Sub Events Label with + Icon -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0"><strong>Sub Events</strong></h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="toggleSubEventsVisibility()"
              *ngIf="!showSubEventsSection" title="Add/Show Sub Events">
              <i class="fas fa-plus"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addSubEvent()"
              *ngIf="showSubEventsSection" title="Add Sub Event">
              <i class="fas fa-plus"></i>
            </button>
          </div>

          <!-- Sub Events -->
          <div formArrayName="subEvents" *ngIf="showSubEventsSection">
            <div *ngFor="let subEvent of subEventsArray.controls; let i = index" class="mb-4 p-3 border rounded">
              <!-- Sub Event Header with Delete Button Only -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="mb-0"><strong>Sub Event {{ i + 1 }}</strong></h6>
                <button type="button" class="btn btn-sm btn-danger" *ngIf="subEventsArray.length > 0"
                  title="Delete Sub Event" (click)="deleteSubEvent(subEvent.subEventId, i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>

              <div [formGroupName]="i">
                <!-- Sub Event Name -->
                <div class="form-group mb-3">
                  <label>Sub Event Name</label>
                  <input type="text" class="form-control" formControlName="subEventName"
                    placeholder="Enter sub event name">
                </div>

                <!-- Website Available Toggle -->
                <div class="form-group mb-3">
                  <label class="fw-semibold">Website Available</label>
                  <div class="d-flex gap-3 mt-1">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" [id]="'websiteYes_' + i" [value]="true"
                        formControlName="isWebsiteReady">
                      <label class="form-check-label" [for]="'websiteYes_' + i">Yes</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" [id]="'websiteNo_' + i" [value]="false"
                        formControlName="isWebsiteReady">
                      <label class="form-check-label" [for]="'websiteNo_' + i">No</label>
                    </div>
                  </div>
                </div>

                <!-- Fields shown when Website Available = Yes -->
                <div *ngIf="subEvent.get('isWebsiteReady')?.value === true">
                  <div class="form-group mb-3">
                    <label>Sub Event Link</label>
                    <input type="text" class="form-control" formControlName="subEventLink"
                      placeholder="Enter sub event link">
                  </div>
                  <!-- Date Fields -->
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Start Date</label>
                        <input type="date" class="form-control" formControlName="startDate">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>End Date</label>
                        <input type="date" class="form-control" formControlName="endDate">
                      </div>
                    </div>
                  </div>

                  <!-- Time Fields -->
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Start Time</label>
                        <input type="time" class="form-control" formControlName="startTime">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>End Time</label>
                        <input type="time" class="form-control" formControlName="endTime">
                      </div>
                    </div>
                  </div>

                  <!-- Logo Upload -->
                  <div class="form-group mb-3">
                    <label>Logo</label>
                    <input type="file" class="form-control" accept="image/*" (change)="onSubEventFileChange($event, i)">
                    <small *ngIf="subEvent.get('logoPath')?.value" class="text-muted mt-1 d-block">
                      Current: {{ subEvent.get('logoPath')?.value }}
                    </small>
                  </div>
                </div>

                <!-- Poster Image shown when Website Available = No -->
                <div *ngIf="subEvent.get('isWebsiteReady')?.value === false">
                  <div class="form-group mb-3">
                    <label>Poster Image <small class="text-muted">(shown on CIFA website only)</small></label>
                    <input type="file" class="form-control" accept="image/*" (change)="onPosterFileChange($event, i)">
                    <small *ngIf="subEvent.get('posterImage')?.value" class="text-muted mt-1 d-block">
                      Current: {{ subEvent.get('posterImage')?.value }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEventModal()">Close</button>
        <button *ngIf="eventForm.get('mainEventSeq')" type="button" class="btn btn-primary" (click)="onSubmit()">Update
          Event</button>
        <button *ngIf="!eventForm.get('mainEventSeq')" type="button" class="btn btn-primary" (click)="onSubmit()">Save
          Event</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [ngClass]="{'show': showEventModal}"
  [style.display]="showEventModal ? 'block' : 'none'"></div>

<!-- View Event Modal -->
<div class="modal fade" id="viewEventModal" tabindex="-1" [ngClass]="{'show': showViewModal}"
  [style.display]="showViewModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 class="modal-title mb-0">Event Details</h5>
          <button *ngIf="selectedEvent?.mainEventSeq" type="button" class="btn btn-sm btn-danger ms-3"
            (click)="deleteMainEvent(selectedEvent.mainEventSeq)" title="Delete Main Event">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <button type="button" class="btn-close" (click)="closeViewModal()"></button>
      </div>
      <div class="modal-body" *ngIf="selectedEvent">
        <!-- Loading Indicator -->
        <div *ngIf="isLoadingViewModal" class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Loading sub-events...</p>
        </div>

        <!-- Content -->
        <div *ngIf="!isLoadingViewModal">
          <!-- Main Event Name -->
          <div class="mb-3">
            <h6 class="fw-semibold">Main Event Name:</h6>
            <p>{{ selectedEvent.mainEventName }}</p>
          </div>
          <div class="mb-3">
            <h6 class="fw-semibold">Main Event Link:</h6>
            <p>{{ selectedEvent.mainEventLink }}</p>
          </div>

          <hr>

          <!-- Sub Events -->
          <h6 class="fw-semibold mb-3">Sub Events (Count: {{ selectedEvent.subEvents?.length || 0 }})</h6>
          <div *ngIf="selectedEvent.subEvents && selectedEvent.subEvents.length > 0">
            <div *ngFor="let subEvent of selectedEvent.subEvents; let i = index" class="border rounded p-3 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0 fw-bold text-primary">Sub Event {{ i + 1 }}: {{ subEvent.subEventName }}</h6>
                <button type="button" class="btn btn-sm btn-danger" (click)="deleteSubEvent(subEvent.subEventId, i)"
                  title="Delete Sub Event">
                  <i class="fas fa-trash"></i>
                </button>
              </div>

              <!-- Website Available -->
              <div class="mb-3">
                <h6 class="fw-semibold text-muted">Website Available:</h6>
                <p class="mb-0">
                  <span [class]="subEvent.isWebsiteReady !== false ? 'badge bg-success' : 'badge bg-secondary'">
                    {{ subEvent.isWebsiteReady !== false ? 'Yes' : 'No' }}
                  </span>
                </p>
              </div>

              <!-- Date & Time Details (only if website available) -->
              <div *ngIf="subEvent.isWebsiteReady !== false">
                <!-- Sub Event Link -->
                <div class="mb-3">
                  <h6 class="fw-semibold text-muted">Sub Event Link:</h6>
                  <p class="mb-0">{{ subEvent.subEventLink || 'N/A' }}</p>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6" *ngIf="subEvent.startDate">
                    <h6 class="fw-semibold text-muted">Start Date:</h6>
                    <p class="mb-0">{{ subEvent.startDate }}</p>
                  </div>
                  <div class="col-md-6" *ngIf="subEvent.endDate">
                    <h6 class="fw-semibold text-muted">End Date:</h6>
                    <p class="mb-0">{{ subEvent.endDate }}</p>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-6" *ngIf="subEvent.startTime">
                    <h6 class="fw-semibold text-muted">Start Time:</h6>
                    <p class="mb-0">{{ subEvent.startTime }}</p>
                  </div>
                  <div class="col-md-6" *ngIf="subEvent.endTime">
                    <h6 class="fw-semibold text-muted">End Time:</h6>
                    <p class="mb-0">{{ subEvent.endTime }}</p>
                  </div>
                </div>

                <!-- Logo -->
                <div class="mb-3" *ngIf="logoImages[subEvent.subEventId] || subEvent.logoPath">
                  <h6 class="fw-semibold text-muted">Logo:</h6>
                  <img *ngIf="logoImages[subEvent.subEventId]" [src]="logoImages[subEvent.subEventId]" alt="Logo"
                    class="img-fluid" style="max-height: 300px;">
                </div>
              </div>

              <!-- Poster (only if website not available) -->
              <div *ngIf="subEvent.isWebsiteReady === false" class="mb-3">
                <h6 class="fw-semibold text-muted">Poster Image: <small>(shown on CIFA website only)</small></h6>
                <img *ngIf="posterImages[subEvent.subEventId]" [src]="posterImages[subEvent.subEventId]" alt="Poster"
                  class="img-fluid" style="max-height: 300px;">
                <p class="mb-0 text-muted" *ngIf="!posterImages[subEvent.subEventId]">No poster uploaded</p>
              </div>

              <!-- Status (if available) -->
              <div class="mb-3" *ngIf="subEvent.status">
                <h6 class="fw-semibold text-muted">Status:</h6>
                <p class="mb-0">{{ subEvent.status }}</p>
              </div>

              <!-- Created At (if available) -->
              <div class="mb-3" *ngIf="subEvent.createdAt">
                <h6 class="fw-semibold text-muted">Created At:</h6>
                <p class="mb-0">{{ subEvent.createdAt | date: 'medium' }}</p>
              </div>

              <!-- Updated At (if available) -->
              <div class="mb-3" *ngIf="subEvent.updatedAt">
                <h6 class="fw-semibold text-muted">Updated At:</h6>
                <p class="mb-0">{{ subEvent.updatedAt | date: 'medium' }}</p>
              </div>

              <!-- Divider between sub events -->
              <hr *ngIf="i < selectedEvent.subEvents.length - 1">
            </div>
          </div>

          <!-- No Sub Events Message -->
          <div *ngIf="!selectedEvent.subEvents || selectedEvent.subEvents.length === 0" class="alert alert-info">
            No sub-events found for this event.
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeViewModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- View Event Modal Backdrop -->
<div class="modal-backdrop fade" [ngClass]="{'show': showViewModal}" [style.display]="showViewModal ? 'block' : 'none'">
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>